import { Card } from "./ui/card";
import { Alpaca, calculateAge } from "@/lib/api";

interface AlpacaCardProps {
  alpaca: Alpaca;
}

const AlpacaCard = ({ alpaca }: AlpacaCardProps) => {
  // Use birthDate to calculate age if available, otherwise use fixed age
  const displayAge = alpaca.birthDate ? calculateAge(alpaca.birthDate) : alpaca.age;

  return (
    <Card className="overflow-hidden group hover-lift">
      <div className="aspect-square overflow-hidden bg-muted">
        <img
          src={alpaca.image}
          alt={alpaca.name}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-2xl font-bold text-foreground">{alpaca.name}</h3>
          <span className="text-sm text-muted-foreground">{displayAge} jaar</span>
        </div>
        <p className="text-sm font-medium text-primary mb-3">{alpaca.color}</p>
        <p className="text-muted-foreground mb-4 whitespace-pre-line">{alpaca.description}</p>
        {alpaca.funFact && (
          <div className="bg-[rgba(255,214,102,0.1)] rounded-lg p-3 mt-4">
            <p className="text-sm font-medium text-[#673F21]">💫 Fun fact: {alpaca.funFact}</p>
          </div>
        )}
      </div>
    </Card>
  );
};

export default AlpacaCard;
